<template>
  <v-dialog v-model="dialog" persistent max-width="760">
    <v-card :key="key">
      <v-app-bar flat color="primary">
        <v-toolbar-title class="text-h6 white--text pl-0">
          Pedidos por aceptar
          <v-chip small dark color="white" class="ml-2 primary--text font-weight-bold" v-if="orders.length">{{ orders.length }}</v-chip>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="$emit('close')" :title="$t('Cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text style="max-height: 70vh; overflow-y: auto" class="pt-4">
        <div v-if="cargando" class="text-center grey--text py-8">Cargando…</div>
        <div v-else-if="orders.length === 0" class="text-center grey--text py-10">
          <v-icon large color="grey lighten-1">mdi-clipboard-check-outline</v-icon>
          <div class="mt-2 font-weight-bold">No hay pedidos por aceptar</div>
          <div class="caption">Aquí llegan los pedidos que mandan los meseros.</div>
        </div>

        <div v-for="item in orders" :key="item.id || item.local_reference" class="por-aceptar">
          <div class="por-aceptar__cabecera">
            <v-chip small dark :color="tipo(item).color">
              <v-icon left small>{{ tipo(item).icono }}</v-icon>{{ tipo(item).texto }}
            </v-chip>
            <span class="por-aceptar__mesero" v-if="item.data_seller && item.data_seller.name">
              <v-icon small>mdi-account-outline</v-icon> {{ item.data_seller.name }}
            </span>
            <v-spacer></v-spacer>
            <span :class="minutos(item) >= 5 ? 'red--text font-weight-bold' : 'grey--text text--darken-1'">{{ hace(item) }}</span>
          </div>

          <div class="por-aceptar__cliente" v-if="nombreCliente(item)">
            <strong>{{ nombreCliente(item) }}</strong>
            <span v-if="item.data_customer && item.data_customer.phone"><v-icon x-small>mdi-phone-outline</v-icon> {{ item.data_customer.phone }}</span>
            <span v-if="direccion(item)"><v-icon x-small>mdi-map-marker-outline</v-icon> {{ direccion(item) }}</span>
            <span v-if="item.data_domiciliary && item.data_domiciliary.name"><v-icon x-small>mdi-moped-outline</v-icon> Domiciliario: {{ item.data_domiciliary.name }}</span>
          </div>

          <div class="por-aceptar__lineas">
            <div v-for="(l, i) in lineas(item)" :key="i" class="por-aceptar__linea">
              <div class="por-aceptar__nombre">
                <span class="por-aceptar__cantidad">{{ l.cantidad }}×</span> {{ l.nombre }}
                <span class="por-aceptar__precio">{{ $filters.currency(l.total, 0) }}</span>
              </div>
              <div class="por-aceptar__detalle" v-for="(d, j) in l.detalle" :key="j">{{ d }}</div>
              <div class="por-aceptar__nota" v-if="l.nota"><v-icon x-small color="amber darken-3">mdi-comment-text-outline</v-icon> {{ l.nota }}</div>
            </div>
            <div class="por-aceptar__nota" v-if="item.note"><v-icon x-small color="amber darken-3">mdi-comment-text-outline</v-icon> Nota del pedido: {{ item.note }}</div>
          </div>

          <div class="red--text caption mb-2" v-if="errores[item.id]">
            <v-icon x-small color="red">mdi-alert-circle</v-icon> {{ errores[item.id] }}
          </div>

          <div class="por-aceptar__pie">
            <span class="por-aceptar__total">{{ $filters.currency(item.total_to_pay, 0) }}</span>
            <v-spacer></v-spacer>
            <v-btn outlined color="red darken-1" :disabled="item.id == currentorderId" @click="abrirRechazo(item)">
              Rechazar
            </v-btn>
            <v-btn color="success" depressed class="ml-2" :loading="item.id == currentorderId" :disabled="!!currentorderId"
              @click="accept(item)">
              <v-icon left>mdi-check</v-icon>Aceptar
            </v-btn>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" @click="$emit('close')" :title="$t('Cancel')">
          Cerrar
        </v-btn>
      </v-card-actions>

      <v-dialog v-model="rechazando" max-width="560" persistent>
        <v-card v-if="porRechazar">
          <v-card-title class="text-h6">Devolver o anular el pedido</v-card-title>
          <v-card-text>
            <p class="mb-3">
              {{ tipo(porRechazar).texto }}<template v-if="porRechazar.data_seller && porRechazar.data_seller.name"> · {{ porRechazar.data_seller.name }}</template>
              · {{ $filters.currency(porRechazar.total_to_pay, 0) }}. Elige el motivo: puedes devolverlo al mesero para que lo corrija o anularlo del todo.
            </p>
            <div class="mb-3" v-if="$store.getters.isRestaurant && lineas(porRechazar).length > 1">
              <div class="caption mb-1">¿Qué producto hay que cambiar? (opcional, al devolver)</div>
              <v-checkbox v-for="(l, i) in lineas(porRechazar)" :key="'l' + i" v-model="lineasSel" :value="i" dense hide-details
                :label="l.cantidad + '× ' + l.nombre" class="mt-0"></v-checkbox>
            </div>
            <div class="mb-3">
              <v-chip v-for="m in motivos" :key="m.id" small class="mr-1 mb-1" :outlined="!motivoSel || motivoSel.id !== m.id"
                :color="motivoSel && motivoSel.id === m.id ? 'primary' : undefined" @click="motivoSel = m">{{ m.name }}</v-chip>
            </div>
            <ng-textarea-keyboard v-model="motivo" :label="motivoSel && motivoSel.requires_note ? 'Nota (obligatoria)' : 'Nota (opcional)'" :filled="false" :dense="false"></ng-textarea-keyboard>
            <div class="red--text caption" v-if="errorRechazo">{{ errorRechazo }}</div>
          </v-card-text>
          <v-card-actions class="flex-wrap">
            <v-spacer></v-spacer>
            <v-btn text :disabled="enviandoRechazo" @click="cerrarRechazo">Volver</v-btn>
            <v-btn outlined color="red darken-1" :disabled="!puedeRechazar || enviandoRechazo"
              @click="confirmarRechazo('annulled')">Anular pedido</v-btn>
            <v-btn v-if="$store.getters.isRestaurant" color="deep-orange darken-1" class="white--text" depressed :loading="enviandoRechazo" :disabled="!puedeRechazar"
              @click="confirmarRechazo('returned')">Devolver al mesero</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<style>
.bg_modal {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) 0% 0% /
    cover no-repeat;
}

.por-aceptar {
  margin-bottom: 14px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  background: #fff;
}

.por-aceptar__cabecera {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.por-aceptar__mesero {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.por-aceptar__cliente {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 14px;
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 0.9rem;
  background: rgba(0, 0, 0, 0.04);
}

.por-aceptar__linea {
  padding: 6px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.por-aceptar__nombre {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 1.05rem;
  font-weight: 700;
}

.por-aceptar__cantidad {
  color: #1976d2;
}

.por-aceptar__precio {
  margin-left: auto;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.por-aceptar__detalle {
  margin-top: 2px;
  padding-left: 10px;
  border-left: 3px solid rgba(25, 118, 210, 0.35);
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.por-aceptar__nota {
  margin-top: 4px;
  font-size: 0.9rem;
  font-style: italic;
  color: rgba(0, 0, 0, 0.7);
}

.por-aceptar__pie {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
/* Pantalla angosta (celular): el total arriba y los dos botones repartidos en el ancho, sin salirse de la tarjeta. */
@media (max-width: 520px) {
  .por-aceptar__total {
    flex: 1 0 100%;
  }
  .por-aceptar__pie > .v-btn {
    flex: 1 1 0;
    min-width: 0;
    margin-left: 0 !important;
  }
}

.por-aceptar__total {
  font-size: 1.25rem;
  font-weight: 800;
}
</style>
<script>
export default {
  components: {},
  name: "CartPendingOrdersReceived",
  data: () => ({
    lineasSel: [],
    orders: [],
    key: 0,
    currentorderId: null,
    cargando: false,
    errores: {},
    rechazando: false,
    porRechazar: null,
    motivo: "",
    errorRechazo: "",
    enviandoRechazo: false,
    motivos: [],
    motivoSel: null,
  }),
  computed: {
    puedeRechazar() {
      if (!this.motivoSel) return false;
      return !this.motivoSel.requires_note || this.motivo.trim().length >= 3;
    },
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {

  },
  methods: {
    async getPendingOrders() {
      this.cargando = true;
      this.orders = [];
      try {
        const pedidos = await this.$pos.getOpenedOrdersToReceive();
        // El que lleva más tiempo esperando va primero.
        this.orders = [...(pedidos || [])].sort((a, b) => String(a.opening_date || "").localeCompare(String(b.opening_date || "")));
      } finally {
        this.cargando = false;
      }
    },
    cancel() {
      this.orders = [];
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    tipo(o) {
      if (o.is_domicile) return { texto: "Domicilio", icono: "mdi-moped-outline", color: "deep-orange darken-1" };
      if (o.name_table) return { texto: o.name_table, icono: "mdi-table-furniture", color: "primary" };
      if (o.store_pickup) return { texto: "Para llevar", icono: "mdi-bag-personal-outline", color: "teal darken-1" };
      return { texto: "Sin mesa", icono: "mdi-help-circle-outline", color: "grey" };
    },
    nombreCliente(o) {
      const c = o.data_customer;
      if (!c) return "";
      return [c.first_name || c.name || c.business_name, c.last_name].filter(Boolean).join(" ");
    },
    direccion(o) {
      if (o.data_customer && o.data_customer.address) return o.data_customer.address;
      const d = o.shipping_address;
      if (!d) return "";
      return typeof d === "string" ? d : d.address || "";
    },
    minutos(o) {
      if (!o.opening_date) return 0;
      const t = Date.parse(String(o.opening_date).replace(" ", "T"));
      return isNaN(t) ? 0 : Math.max(0, Math.round((Date.now() - t) / 60000));
    },
    hace(o) {
      const min = this.minutos(o);
      if (min < 1) return "ahora";
      if (min < 60) return "hace " + min + " min";
      const h = Math.floor(min / 60);
      return "hace " + h + (h === 1 ? " hora" : " horas");
    },
    // Las líneas del pedido en texto simple: lo que cocina va a preparar, con variante, opciones y notas.
    lineas(o) {
      let items = o.data_items;
      if (typeof items === "string") {
        try {
          items = JSON.parse(items);
        } catch (e) {
          items = [];
        }
      }
      return (items || []).map((l) => {
        const detalle = [];
        if (l.product_variant && l.product_variant.name) detalle.push(l.product_variant.name);
        const opciones = l.options || {};
        for (const k of Object.keys(opciones)) {
          const op = opciones[k];
          if (!op || op.option_type !== "custom") continue;
          const valor = Array.isArray(op.value) ? op.value.join(", ") : op.value;
          if (valor) detalle.push(op.name + ": " + valor);
        }
        for (const sub of l.sub_items || []) {
          detalle.push(sub.quantity + " × " + sub.product.name);
        }
        return {
          cantidad: parseFloat(l.quantity) || 0,
          nombre: (l.product && l.product.name) || l.product_name || "Producto",
          total: l.total_amount,
          detalle,
          nota: l.note,
        };
      });
    },
    async accept(item) {
      this.currentorderId = item.id;
      this.$delete(this.errores, item.id);
      try {
        const turno = this.$store.getters.turn;
        const response = await this.$http.post("api/v1/order/change-status/" + item.id + "", {
          order_status: "received",
          time: this.$filters.currentDatetime(),
          // El pedido del mesero llega sin turno: aceptado, es del turno de esta caja y sale en la pantalla de pedidos.
          bill_cash_register_turn_id: (turno && turno.id) || null,
        });
        if (response && response.success) {
          this.quitar(item);
        } else {
          this.$set(this.errores, item.id, (response && (response.msg || response.message)) || "No se pudo aceptar el pedido. Inténtalo de nuevo.");
        }
      } catch (e) {
        this.$set(this.errores, item.id, (e && (e.msg || e.message)) || "No se pudo aceptar el pedido. Revisa la conexión e inténtalo de nuevo.");
      } finally {
        this.currentorderId = null;
      }
    },
    quitar(item) {
      const i = this.orders.findIndex((el) => el.id === item.id);
      if (i !== -1) {
        this.orders.splice(i, 1);
      }
      if (this.orders.length === 0) {
        this.$store.commit("setOrderReceived", false);
      }
      this.$store.commit("createdOrder", true);
    },
    async abrirRechazo(item) {
      this.porRechazar = item;
      this.motivo = "";
      this.motivoSel = null;
      this.lineasSel = [];
      this.errorRechazo = "";
      this.rechazando = true;
      try {
        const r = await this.$http.get("api/v1/pos/motivos-de-anulacion", {});
        this.motivos = (r && r.items) || [];
      } catch (e) {
        this.motivos = [];
      }
    },
    cerrarRechazo() {
      this.rechazando = false;
      this.porRechazar = null;
    },
    async confirmarRechazo(estado) {
      const item = this.porRechazar;
      if (!item || !this.puedeRechazar) return;
      this.enviandoRechazo = true;
      this.errorRechazo = "";
      try {
        const response = await this.$http.post("api/v1/order/change-status/" + item.id + "", {
          order_status: estado,
          time: this.$filters.currentDatetime(),
          lines: estado === "returned" ? this.lineasSel.slice().sort().map((i) => ({ index: i, name: this.lineas(item)[i].nombre })) : undefined,
          reason_id: this.motivoSel.id,
          reason: this.motivo.trim(),
        });
        if (response && response.success) {
          this.quitar(item);
          this.cerrarRechazo();
        } else {
          this.errorRechazo = (response && (response.msg || response.message)) || "No se pudo rechazar el pedido. Inténtalo de nuevo.";
        }
      } catch (e) {
        this.errorRechazo = (e && (e.msg || e.message)) || "No se pudo rechazar el pedido. Revisa la conexión e inténtalo de nuevo.";
      } finally {
        this.enviandoRechazo = false;
      }
    },
  },
};
</script>
